import { Checkbox, ScrollArea, Table } from '@mantine/core'
import { useState } from 'react'
import TableHeaderColumn from './TableHeaderColumn'
import TableRowOneColumn from './TableRowOneColumn'
import { ITable } from '@interfaces/ITable'

const TableTemplate = <T,>({
    height,
    thead,
    order,
    orderby,
    setorder,
    setorderby,
    setSelection,
    selection,
    lists = [],
    children,
    KeyID,
}: ITable<T>) => {
    const [defaultOrderBy] = useState(orderby)

    const setSorting = (field: keyof T) => {
        const reversed =
            field === orderby ? (order === 'desc' ? 'asc' : 'desc') : 'desc'
        setorder(reversed)
        const resetFieldAt3 =
            (field === orderby ? (order === 'desc' ? '2' : '3') : '1') === '3'
                ? true
                : false

        setorderby(resetFieldAt3 ? (defaultOrderBy as keyof T) : field)
    }

    const toggleAll = (key: keyof T) => {
        console.log('lists=>', lists)
        setSelection((current) =>
            current!.length === lists!.length
                ? []
                : lists!.map((item: any) => item[key] ?? item[key])
        )
    }

    return (
        <>
            <ScrollArea
                mt='md'
                style={{
                    maxHeight: `calc(${height} - 207px)`,
                    height: height,
                    overflowY: 'scroll',
                }}
            >
                <Table pos={'relative'}>
                    <thead>
                        <tr>
                            <Table.Th style={{ width: '5%' }}>
                                <Checkbox
                                    onChange={() => toggleAll(KeyID)}
                                    checked={
                                        selection.length === lists.length &&
                                        selection.length > 0
                                    }
                                    indeterminate={
                                        selection.length > 0 &&
                                        selection.length !== lists.length
                                    }
                                />
                            </Table.Th>
                            {thead.map((th, index) => (
                                <TableHeaderColumn
                                    key={index}
                                    sorted={orderby === th.sortkey}
                                    reversed={order === 'desc' ? true : false}
                                    onSort={
                                        th.sortkey
                                            ? () => setSorting(th.sortkey!)
                                            : undefined
                                    }
                                    label={th.label}
                                    width={th.width}
                                />
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {lists ? (
                            lists.length > 0 ? (
                                children
                            ) : (
                                <TableRowOneColumn>
                                    ไม่พบข้อมูล
                                </TableRowOneColumn>
                            )
                        ) : (
                            <TableRowOneColumn>Loading...</TableRowOneColumn>
                        )}
                    </tbody>
                </Table>
            </ScrollArea>
        </>
    )
}

export default TableTemplate
